function scriptLoad(url, id, load) {
  if(id && !document.getElementById(id)) {
    var s = document.createElement('script');
    s.id = id;
    s.type = 'text/javascript';
    s.async = true;
    s.src = url;
    if (typeof load === 'function') {
      s.onload = load;
    }
    var x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  }
};

document.addEventListener('DOMContentLoaded', function() {
  (function($){
    // Astute chatbot passive loader
    
    $('.chatbot-container-btn').on('click', function() {
      let self = $(this);
      
      let astuteOnLoad = function() {
        astuteBotLauncher.init({
          secondsBeforeDisplaying: 0,
          chatInitiallyVisible: false,
          hideLauncherButtonWhenChatVisible: true,
          toggleChatMarkup: '',
          titleMarkup: 'Welcome to AZO!',
          autoGetStarted: true,
          conversationServiceId: '',
          persistConversationAcrossSession: true,
          wasClosed: true,
          fullScreenMobile: !1,
          allowMicrophone: !1,
          replyHeightPixels: 36,
          botUrl: window.astuteBotMessengerSettings.channelId
        });
        
        // wait for Astute messenger js to load
        // there's no callback for the astuteBotLauncher implementation
        setTimeout(function () {
          // remove our temporary icon
          self.remove();
          
          // display chat after clicked
          astuteBotLauncher.showChat();
        }, 750);
      }
      
      scriptLoad(window.astuteBotMessengerSettings.chatbot, 'astutebot-messenger', astuteOnLoad);
    });
  })(jQuery);
});



$(document).ready(function(){
  setTimeout(myGreeting, 5000);
  function myGreeting() {
    
    mobileOnlySlider(".related-product", true, false, 767);
    function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
      var slider = $($slidername);
      var settings = {
        mobileFirst: true,
        dots: $dots,
        arrows: $arrows,
        
        responsive: [
          {
            breakpoint: $breakpoint,
            settings: "unslick"
          }
        ]
      };
      
      slider.slick(settings);
      $(window).on("resize", function () {
        if ($(window).width() > $breakpoint) {
          return;
        }
        
        if (!slider.hasClass("slick-initialized")) {
          return slider.slick(settings);
        }
      });
    } // Mob
  }
});